import { useTranslations } from "next-intl";
import { useState } from "react";
import ahoy from "@lib/ahoy";
import { useRouter } from "@lib/i18n/navigation-pages-router";
import { useCurrentUser } from "@hooks/use-current-user";
import useCustomizableCloset from "@hooks/use-customizable-closet";
import Image from "@components/core/Image";
import Button from "@components/core/Button";
import closetStates from "@utils/constants/closetStates";
import UnsubscribeModal from "./UnsubscribeModal";

function SubscriptionCancelationAskNew({ currentCoupon }) {
  const t = useTranslations("accounts");

  const router = useRouter();
  const user = useCurrentUser();
  const currentCloset = useCustomizableCloset();

  const [unsubscribeModalOpened, setUnsubscribeModalOpened] = useState("");

  function sendEventsUserAskForCancelation() {
    ahoy("$click", { button: "wantUnsubscribe" });
    // eslint-disable-next-line no-undef
    if (typeof _cio !== "undefined") _cio.track("ClickWantUnsubscribe");
  }

  function openUnsubscribeModal(e) {
    e.preventDefault();

    sendEventsUserAskForCancelation();

    if (!user.received_at_least_one_closet) {
      setUnsubscribeModalOpened("ask_customer_service");
      return;
    }

    if (user.closets_count === 1 && currentCloset.state === closetStates.received) {
      setUnsubscribeModalOpened("try_another_closet");
      return;
    }

    if (user.subscription.plan_price.plan.unlimited) {
      setUnsubscribeModalOpened("unlimited_retention");
      return;
    }

    router.push("/profile/manage-subscription/cancelation");
  }

  return (
    <div
      data-testid="manage-subscription-cancelation-new-section"
      className="manage-subscription-card"
    >
      <div className="manage-subscription-card-content">
        <div className="p-3 d-flex flex-column align-items-center">
          <h5 className="text-center mb-0">{t("manage_subscription.cancelation.new.title")}</h5>

          <div
            className="my-5"
            style={{ width: "128px" }}
          >
            <Image
              src="handbagSadNeon"
              alt={t("manage_subscription.cancelation.alt_sad")}
              className="w-100"
            />
          </div>

          <p className="text-center">{t("manage_subscription.cancelation.new.description")}</p>
        </div>

        <div className="p-2 d-flex justify-content-center border-top">
          <Button
            variant="ghost-primary"
            onClick={openUnsubscribeModal}
          >
            {t("manage_subscription.cancelation.new.cancel_subscription")}
          </Button>
        </div>
      </div>

      <UnsubscribeModal
        unsubscribeModalOpened={unsubscribeModalOpened}
        close={() => setUnsubscribeModalOpened("")}
        currentCoupon={currentCoupon}
      />
    </div>
  );
}

export default SubscriptionCancelationAskNew;
